import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { fullScreenPlugin } from "@react-pdf-viewer/full-screen";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/zoom/lib/styles/index.css";
import "@react-pdf-viewer/full-screen/lib/styles/index.css";

// Ajuste a versão conforme seu package.json (npm ls pdfjs-dist)
const defaultWorkerUrl = "https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js";

const btnStyle = {
  border: "1px solid #ddd",
  borderRadius: 8,
  padding: "6px 10px",
  background: "#fff",
  cursor: "pointer",
  lineHeight: 1,
};

const PdfViewer = ({ url, height = 600, workerUrl }) => {
  const zoomPluginInstance = zoomPlugin();
  const { ZoomIn, ZoomOut, ZoomPopover } = zoomPluginInstance;

  const fullScreenPluginInstance = fullScreenPlugin();
  const { EnterFullScreen } = fullScreenPluginInstance;

  return (
    <div style={{ border: "1px solid #ccc", display: "flex", flexDirection: "column", height }}>
      {/* Barra de Ferramentas */}
      <div
        style={{
          display: "flex", gap: 8, padding: 8, alignItems: "center",
          borderBottom: "1px solid #eee", background: "#fafafa",
        }}
      >
        <ZoomOut>{(props) => <button onClick={props.onClick} style={btnStyle}>−</button>}</ZoomOut>
        <ZoomPopover>
          {(props) => (
            <button onClick={props.onClick} style={{ ...btnStyle, minWidth: 64 }}>
              {Math.round(props.scale * 100)}%
            </button>
          )}
        </ZoomPopover>
        <ZoomIn>{(props) => <button onClick={props.onClick} style={btnStyle}>+</button>}</ZoomIn>
        <div style={{ flex: 1 }} />
        <EnterFullScreen>{(props) => <button onClick={props.onClick} style={btnStyle}>⛶</button>}</EnterFullScreen>
      </div>

      {/* Área do PDF */}
      <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <Worker workerUrl={workerUrl || defaultWorkerUrl}>
          <Viewer fileUrl={url} plugins={[zoomPluginInstance, fullScreenPluginInstance]} />
        </Worker>
      </div>
    </div>
  );
};

export default PdfViewer;